import { HTMLTag } from '@/src/cms/domain/models/metadata/html-tag';

import { cmsBlockPresentersMap } from '../../presenters/blocks';
import { SEOTextBlockViewModel } from '../blocks/seo-text-block.viewModel';
import { TextImageBlockViewModel } from '../blocks/text-image-block.viewModel';

import { BaseCMSPageContentViewModel } from './base-cms-page-content.viewModel';

import type { IBaseCMSPageContentViewModel } from './base-cms-page-content.viewModel.types';
import type { CMSBlockViewModel } from '../../types/cms-block.viewModel';
import type { CMSBlocksPageContent } from '@/src/cms/domain/models/pages/cms-blocks-page-content';

export class CMSBlocksPageContentViewModel extends BaseCMSPageContentViewModel {
  readonly $type = 'blocksPage' as const;

  readonly blocks: CMSBlockViewModel[];

  constructor(data: { blocks?: CMSBlockViewModel[] } & IBaseCMSPageContentViewModel) {
    super(data);

    this.blocks =
      data.blocks?.map((block) => {
        switch (block.$type) {
          case 'text-image-block':
            return new TextImageBlockViewModel(block);
          case 'seo-text-block':
            return new SEOTextBlockViewModel(block);
          default:
            throw new Error(`Unknown block type: ${block.$type}`);
        }
      }) || [];
  }

  static presenter(entity: CMSBlocksPageContent): CMSBlocksPageContentViewModel {
    return new CMSBlocksPageContentViewModel({
      title: entity.title,
      htmlTags: entity.htmlTags.map((t) => new HTMLTag(t)),
      hrefLang: entity.hrefLang,
      canonicalUrl: entity.canonicalUrl,
      metaTitle: entity.metaTitle,
      metaDescription: entity.metaDescription,
      ogTitle: entity.ogTitle,
      ogDescription: entity.ogDescription,
      ogUrl: entity.ogUrl,
      twitterTitle: entity.twitterTitle,
      twitterDescription: entity.twitterDescription,
      twitterImageAlt: entity.twitterImageAlt,
      robots: entity.robots,
      // FIXME
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      blocks: entity.blocks?.map((item) => cmsBlockPresentersMap[item.$type](item as any))
    });
  }
}
